export default __webpack_public_path__ + "static/media/user.05d0404a.png";